/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
    CurrencyToJSONTyped,
} from './Currency';
import type { PaymentSplitDtoV2 } from './PaymentSplitDtoV2';
import {
    PaymentSplitDtoV2FromJSON,
    PaymentSplitDtoV2FromJSONTyped,
    PaymentSplitDtoV2ToJSON,
    PaymentSplitDtoV2ToJSONTyped,
} from './PaymentSplitDtoV2';
import type { InitiateUnintegratedPaymentV2Request } from './InitiateUnintegratedPaymentV2Request';
import {
    InitiateUnintegratedPaymentV2RequestFromJSON,
    InitiateUnintegratedPaymentV2RequestFromJSONTyped,
    InitiateUnintegratedPaymentV2RequestToJSON,
    InitiateUnintegratedPaymentV2RequestToJSONTyped,
} from './InitiateUnintegratedPaymentV2Request';

/**
 * 
 * @export
 * @interface FavritGiftCard
 */
export interface FavritGiftCard extends InitiateUnintegratedPaymentV2Request {
    /**
     * 
     * @type {string}
     * @memberof FavritGiftCard
     */
    giftCardId: string;
}



/**
 * Check if a given object implements the FavritGiftCard interface.
 */
export function instanceOfFavritGiftCard(value: object): value is FavritGiftCard {
    if (!('giftCardId' in value) || value['giftCardId'] === undefined) return false;
    return true;
}

export function FavritGiftCardFromJSON(json: any): FavritGiftCard {
    return FavritGiftCardFromJSONTyped(json, false);
}

export function FavritGiftCardFromJSONTyped(json: any, ignoreDiscriminator: boolean): FavritGiftCard {
    if (json == null) {
        return json;
    }
    return {
        ...InitiateUnintegratedPaymentV2RequestFromJSONTyped(json, true),
        'giftCardId': json['giftCardId'],
    };
}

export function FavritGiftCardToJSON(json: any): FavritGiftCard {
    return FavritGiftCardToJSONTyped(json, false);
}

export function FavritGiftCardToJSONTyped(value?: FavritGiftCard | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        ...InitiateUnintegratedPaymentV2RequestToJSONTyped(value, true),
        'giftCardId': value['giftCardId'],
    };
}

